import AxiosAPI from "./axiosInstance";
import {
  existingCustomerResponse,
  createCustomerResponse,
  createAddressResponse,
  getAvailableSlotsResponse,
  createAppointementResponse,
} from "./demoData";
let getSchedulerDataServicesInstall = [];
let getSchedulerDataServicesRepair = [];
let getSchedulerDataServicesMaintenance = [];
//console.log(window.location.origin)
let PUBLIC_URL = window.location.origin;
let cookies;
let websiteURL;
if (PUBLIC_URL.indexOf("localhost") !== -1) {
  var switchURL = true;
} else {
  var switchURL = false;
}
switch (switchURL) {
  case true:
    websiteURL = "https://autobot.ai";
    cookies = document.cookie;
    break;
  case false:
    websiteURL = window.location.origin;
    break;
  default:
    websiteURL = window.location.origin;
    break;
}

const handleAsyncEvent = async (event) => {
  const data = event?.data;
  if (data?.siteUrl !== undefined) {
    websiteURL = data?.siteUrl;
    cookies = data?.cookies;
  }
};
window.addEventListener("message", handleAsyncEvent);
// let websiteURL = window.location.origin
export const getSchedulerData = async () => {
  const response = await AxiosAPI.post(`/scheduler_get_start`, {
    websiteUrl: websiteURL,
  });
  //console.log("hice el coso")
  let servicesArray = Object.values(response.data.offeredJobs);

  Object.keys(servicesArray).forEach(function(values) {
    if (Object.keys(servicesArray[values]).includes("estimate")) {
      getSchedulerDataServicesInstall.push(
        servicesArray[values].estimate["Universal Job"]
      );
    }
  });
  Object.keys(servicesArray).forEach(function(values) {
    if (Object.keys(servicesArray[values]).includes("repair")) {
      getSchedulerDataServicesRepair.push(
        servicesArray[values].repair["Universal Job"]
      );
    }
  });
  Object.keys(servicesArray).forEach(function(values) {
    if (Object.keys(servicesArray[values]).includes("maintenance")) {
      getSchedulerDataServicesMaintenance.push(
        servicesArray[values].maintenance["Universal Job"]
      );
    }
  });

  return response.data;
};

export {
  getSchedulerDataServicesInstall,
  getSchedulerDataServicesRepair,
  getSchedulerDataServicesMaintenance,
}; //Exporting API Call to ALL Services Constructors (../api/Electrical, HeatingCooling, Plumbing)
export const getExistingCustomer = async (accountPhoneNumber) => {
  for (var i = 0; i < cookies.split(";").length; i++) {
    if (
      cookies
        .split(";")
        [i].split("=")[0]
        .trim() === "wc_client_current"
    ) {
      var cookieData = cookies.split(";")[i].split("=")[1];
    }
  }

  if (websiteURL === "https://autobot.ai") {
    return existingCustomerResponse;
  } else {
    const response = await AxiosAPI.post(`/scheduler_get_customer`, {
      websiteUrl: websiteURL,
      phone: accountPhoneNumber,
      cookie: cookieData,
    });

    return response.data;
  }
};

export const createCustomer = async (customerDetail) => {
  // var cookies = document.cookie;
  for (var i = 0; i < cookies.split(";").length; i++) {
    if (
      cookies
        .split(";")
        [i].split("=")[0]
        .trim() === "wc_client_current"
    ) {
      var cookieData = cookies.split(";")[i].split("=")[1];
    }
  }

  if (websiteURL === "https://autobot.ai") {
    return createCustomerResponse;
  } else {
    const response = await AxiosAPI.post(`/scheduler_create_customer`, {
      ...customerDetail,
      websiteUrl: websiteURL,
      cookie: cookieData,
    });
    return response.data;
  }
};

export const createAddress = async (addressDetail) => {
  if (websiteURL === "https://autobot.ai") {
    return createAddressResponse;
  } else {
    const response = await AxiosAPI.post(`/scheduler_create_address`, {
      ...addressDetail,
      websiteUrl: websiteURL,
    });
    return response.data;
  }
};

export const getAvailableSlots = async (serviceDetail) => {
  if (websiteURL === "https://autobot.ai") {
    const availableSlotsData = getAvailableSlotsResponse();
    return availableSlotsData;
  } else {
    const response = await AxiosAPI.post(`/scheduler_get_times`, {
      ...serviceDetail,
      websiteUrl: websiteURL,
    });
    return response.data;
  }
};

export const createAppointement = async (appointmentDetail) => {
  // var cookies = document.cookie;
  for (var i = 0; i < cookies.split(";").length; i++) {
    if (
      cookies
        .split(";")
        [i].split("=")[0]
        .trim() === "wc_client_current"
    ) {
      var cookieData = cookies.split(";")[i].split("=")[1];
    }
  }
  if (websiteURL === "https://autobot.ai") {
    return createAppointementResponse;
  } else {
    const response = await AxiosAPI.post(`/scheduler_post_appointment`, {
      appointmentObj: { ...appointmentDetail },
      websiteUrl: websiteURL,
      cookie: cookieData,
    });
    return response.data;
  }
};

export const validationAddress = async (payload) => {
  const address = {
    address: payload,
    enableUspsCass: true,
  };

  return fetch(
    `https://addressvalidation.googleapis.com/v1:validateAddress?key=${process.env.REACT_APP_GOOGLE_API_KEY}`,
    {
      method: "POST",
      body: JSON.stringify(address),
      headers: { "Content-Type": `application/json` },
    }
  ).then((response) => {
    return response.json();
  });
};
